interface EnvironmentType {
    readonly type: 'staging' | 'production' | 'local' | 'unknown';
}

const env = {
    isProduction: process.env.NODE_ENV === 'production',
    isLocal: window.location.host.indexOf('localhost') >= 0,
    apiBaseUrl:
        window.location.host.indexOf('staging') >= 0 ||
        window.location.host.indexOf('localhost') >= 0
            ? process.env.VUE_APP_API_URL_STAGING
            : process.env.VUE_APP_API_URL_PRODUCTION,
    hotjarId: process.env.VUE_APP_HOTJAR_ID as string | undefined,
    hotjarSv: process.env.VUE_APP_HOTJAR_SV as string | undefined,
    isStaging: window.location.host.indexOf('staging') >= 0,
    captchaKey: process.env.VUE_APP_API_RECAPTCHA_PUBLIC_KEY,
    smartlookProjectId: process.env.VUE_APP_SMARTLOOK_PR_ID,
    personaApiBaseUrl: window.location.host.indexOf('staging') >= 0 ||
        window.location.host.indexOf('localhost') >= 0
        ? process.env.VUE_APP_PERSONA_URL_STAGING
        : process.env.VUE_APP_PERSONA_URL_PRODUCTION,
        geoLocationKey: process.env.VUE_APP_API_GEO_LOCATION    
} as const

const environment: typeof env & EnvironmentType = {
    ...env,
    type: env.isLocal
        ? 'local'
        : env.isStaging
        ? 'staging'
        : env.isProduction
        ? 'production'
        : 'unknown',
}

export default environment
